
import { useState } from 'react';
import { getVolunteerOpportunities } from '../../../api/apiServices';
import { useNavigate } from 'react-router-dom';

export default function VolunteerSection() {
 const navigate = useNavigate();
  const [opportunities, setOpportunities] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
      fetchOpportunities();
    }, []);
  
    const fetchOpportunities = async () => {
      try {
        setLoading(true);
        const res = await getVolunteerOpportunities();
        setOpportunities(res.data || []);
      } catch (err) {
        console.error("Failed to fetch opportunities", err);
      } finally {
        setLoading(false);
      }
    };


  return (
    <section id="volunteer" className="py-16 sm:py-24 px-4 sm:px-6 lg:px-20 bg-gradient-to-b from-white to-[#f5f3fb]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#6a4bc3] mb-3 sm:mb-4">
            Join Our Mission
          </h2>
          <p className="text-gray-600 text-base sm:text-lg">
            Multiple ways to make an impact
          </p>
        </div>

        {/* Opportunities Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-6 mb-8 sm:mb-12">
          {opportunities.map((opportunity) => (
            <div
              key={opportunity._id}
              className="bg-[#f8f6fc] rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 hover:bg-[#6a4bc3] hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group cursor-pointer"
            >
              <div className="w-10 h-10 sm:w-14 sm:h-14 lg:w-16 lg:h-16 flex items-center justify-center mb-3 sm:mb-6">
                <i className={`${opportunity?.icon} text-3xl sm:text-4xl lg:text-5xl text-[#c9a24d] group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-sm sm:text-base lg:text-lg font-semibold text-gray-900 group-hover:text-white transition-colors">
                {opportunity.title}
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 group-hover:text-white/90 mt-1 sm:mt-2 transition-colors hidden sm:block">
                {opportunity.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <button
            onClick={() => navigate("/volunteer")}
            className="bg-[#c9a24d] text-white px-8 sm:px-12 py-3 sm:py-4 rounded-full font-semibold text-sm sm:text-base hover:bg-[#b8923d] transition-all hover:shadow-xl hover:-translate-y-1 inline-flex items-center gap-3 whitespace-nowrap cursor-pointer"
          >
            Apply to Volunteer
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
